import React, { useState, useContext, useEffect } from "react";
import { Nav, Tab } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { ThemeContext } from "../../context/ThemeContext";
import { useSettings } from "../../context/SettingsContext";
import { updateSiteSettings } from "../../store/custom-actions/settings-actions/siteSettingsSlicer";
import ColorPicker from "../components/ui/ColorPicker";

const Setting = () => {
  const dispatch = useDispatch();
  const { getSetting, settings } = useSettings();
  const { changePrimaryColor, changeSecondaryColor } = useContext(ThemeContext);
  const { loading: settingsLoading } = useSelector(
    (state) => state.siteSettingsSlicer
  );

  const [settingToggle, setSettingToggle] = useState(false);

  const [dashboardPrimaryColor, setDashboardPrimaryColor] = useState();
  const [dashboardSecondaryColor, setDashboardSecondaryColor] = useState();
  const [userPanelPrimaryColor, setUserPanelPrimaryColor] = useState();
  const [userPanelsecondaryColor, setUserPanelSecondaryColor] = useState();
  const [userPanelPrimaryHover, setUserPanelPrimaryHover] = useState();

  useEffect(() => {
    if (settings) {
      setDashboardPrimaryColor(getSetting("back_primary_color"));
      setDashboardSecondaryColor(getSetting("back_secondary_color"));
      setUserPanelPrimaryColor(getSetting("front_primary_color"));
      setUserPanelSecondaryColor(getSetting("front_secondary_color"));
      setUserPanelPrimaryHover(getSetting("front_primary_color_hover"));
    }
  }, [settings]);

  const handleSubmitData = () => {
    dispatch(
      updateSiteSettings({
        back_primary_color: dashboardPrimaryColor,
        back_secondary_color: dashboardSecondaryColor,
        front_primary_color: userPanelPrimaryColor,
        front_secondary_color: userPanelsecondaryColor,
        front_primary_color_hover: userPanelPrimaryHover,
      })
    );
  };

  const handleColorChange = (setter, changer) => (value) => {
    if (changer) changer(value);
    setter(value);
  };

  return (
    <div
      className={`sidebar-right settings-panel ${settingToggle ? "show" : ""}`}
      style={{ zIndex: 999999999 }}
    >
      <div className="bg-overlay" onClick={() => setSettingToggle(false)} />

      <Link
        to="#"
        className="sidebar-right-trigger z-[9999999999999] wave-effect wave-effect-x bg-primary"
        onClick={() => setSettingToggle(!settingToggle)}
      >
        <i className="fa fa-cog fa-spin" />
      </Link>

      <Link
        to="#"
        className="sidebar-close-trigger z-[9999999999999]"
        onClick={() => setSettingToggle(false)}
      >
        <i className="la-times las" />
      </Link>

      <div className="sidebar-right-inner settings-panel-inner">
        <div
          className="settings-panel-header rounded-3 mb-3 text-white px-3 py-3"
          style={{
            background: "linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%)",
            boxShadow: "0 4px 14px rgba(0,0,0,0.15)",
          }}
        >
          <h5 className="mb-0 fw-bold d-flex align-items-center gap-2 text-white">
            <i className="fas fa-palette" />
            Pick your style
          </h5>
          <p className="small mb-0 mt-1 opacity-90">Dashboard &amp; User panel colors</p>
        </div>

        <Tab.Container defaultActiveKey="Theme">
          <Nav as="ul" className="nav nav-pills nav-fill gap-1 mb-3" role="tablist">
            <Nav.Item as="li">
              <Nav.Link
                as="button"
                type="button"
                eventKey="Theme"
                className="rounded-pill border-0 shadow-sm"
              >
                <i className="fas fa-tachometer-alt me-1" />
                Dashboard
              </Nav.Link>
            </Nav.Item>
            <Nav.Item as="li">
              <Nav.Link
                as="button"
                type="button"
                eventKey="Header"
                className="rounded-pill border-0 shadow-sm"
              >
                <i className="fas fa-user-circle me-1" />
                User Panel
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <div className="mb-3">
            <button
              type="button"
              className="btn btn-primary w-100 rounded-pill shadow-sm fw-semibold"
              onClick={handleSubmitData}
              disabled={settingsLoading}
            >
              {settingsLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                  Saving...
                </>
              ) : (
                <>
                  <i className="fas fa-save me-2" />
                  Save Changes
                </>
              )}
            </button>
          </div>

          <Tab.Content className="mt-2">
            <Tab.Pane eventKey="Theme">
              <p className="small text-muted mb-3">
                Colors applied to the dashboard (sidebar, buttons, links). Changes preview instantly.
              </p>
              <div className="row g-0">
                <ColorPicker
                  label="Primary Color"
                  selectedColor={dashboardPrimaryColor}
                  setSelectedColor={handleColorChange(
                    setDashboardPrimaryColor,
                    changePrimaryColor
                  )}
                  inputName="theme_primary"
                  disabled={settingsLoading}
                />
                <ColorPicker
                  label="Secondary Color"
                  selectedColor={dashboardSecondaryColor}
                  setSelectedColor={handleColorChange(
                    setDashboardSecondaryColor,
                    changeSecondaryColor
                  )}
                  inputName="theme_secondary"
                  disabled={settingsLoading}
                />
              </div>
            </Tab.Pane>

            <Tab.Pane eventKey="Header">
              <div
                className="alert alert-info border-0 rounded-3 small mb-3 d-flex align-items-start gap-2"
                style={{ backgroundColor: "rgba(13, 110, 253, 0.08)" }}
              >
                <i className="fas fa-info-circle mt-1" />
                <span>
                  User panel colors affect the front store. Refresh the store page after saving to see changes.
                </span>
              </div>
              <div className="row g-0">
                <ColorPicker
                  label="User Panel Primary"
                  selectedColor={userPanelPrimaryColor}
                  setSelectedColor={setUserPanelPrimaryColor}
                  inputName="user_primary"
                  disabled={settingsLoading}
                />
                <ColorPicker
                  label="User Panel Secondary"
                  selectedColor={userPanelsecondaryColor}
                  setSelectedColor={setUserPanelSecondaryColor}
                  inputName="user_secondary"
                  disabled={settingsLoading}
                />
                <ColorPicker
                  label="User Panel Primary Hover"
                  selectedColor={userPanelPrimaryHover}
                  setSelectedColor={setUserPanelPrimaryHover}
                  inputName="user_primary_hover"
                  disabled={settingsLoading}
                />
              </div>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </div>
  );
};

export default Setting;
